import React from 'react';
import classNames from 'classnames';
import Icon from '../../Icon';

const FilterButton = ({className, children, onClick}) => (
    <button className={classNames(className, 'filter-button btn')} type="button" onClick={onClick}>
        <Icon icon="add" />
        {children && <span className="ml-1">{children}</span>}
    </button>
);

export default FilterButton;
